<navigation-menu-element [attr.menu-data-url]="menuDataUrlSafe" [attr.post-favourites-url]="postFavouritesUrl"
  [attr.user-name]="userName" [attr.picture-url]="pictureUrl" [attr.my-profile-url]="myProfileUrl" [attr.contact-url]="contactUrl"
  [attr.logout-url]="logoutUrl" [attr.active-menu-item]="activeMenuItem" [attr.default-service]="defaultService">
</navigation-menu-element>
